import { QueryClientProvider } from '@tanstack/react-query'
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { PostHogProvider } from 'posthog-js/react'
import { queryClient } from '@/lib/api/queryClient'
import { initPostHog, isPostHogEnabled } from '@/lib/analytics'

// Initialize PostHog client (options are applied during init)
const posthogClient = initPostHog()

interface ProvidersProps {
  children: React.ReactNode
}

export function Providers({ children }: ProvidersProps) {
  // Wrap with PostHogProvider only if PostHog is enabled
  const content = (
    <QueryClientProvider client={queryClient}>
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  )

  // If PostHog is enabled and client is initialized, wrap with provider
  // Note: Options were already applied during init, so we only pass the client
  if (isPostHogEnabled() && posthogClient) {
    return <PostHogProvider client={posthogClient}>{content}</PostHogProvider>
  }

  return content
}
